/*
 * @Description:  use-get-common-method 导出公共方法
 * @Author: fiveonelei
 * @Date: 2022-02-09 17:54:29
 * @FilePath: /vise/packages/app-share/src/composable/use-get-common-method/index.ts
 */
import getMiniAppMethods from './get-mini-app-methods';
import getVideoMethods from './get-video-methods';
import getSchemaMethods from './get-schema-methods';
import getGrowthTestMethods from './get-growth-test-methods';

export default function useGetCommonMethods() {
  const miniAppMethods = getMiniAppMethods();
  const videoMethods = getVideoMethods();
  const schemaMethods = getSchemaMethods();
  const growthTestMethods = getGrowthTestMethods();

  return {
    ...miniAppMethods,
    ...videoMethods,
    ...schemaMethods,
    ...growthTestMethods,
  };
}
